import { ScrollStrategy } from '@angular/cdk/overlay';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AppComponent } from 'src/app/app.component';
import { isPartnerPortalUser, UserTypeEnum } from 'src/app/services/common/constant.service';
import { PartnerPortalSidebarService } from 'src/app/services/partner-portal-sidebar.service';
import { StorageService } from 'src/app/services/common/storage.service';
import { UserInfoService } from 'src/app/services/user-info.service';
import { DailogComponent } from 'src/app/shared/widgets/dailog/dailog.component';
import { SubscriptionPlanComponent } from 'src/app/shared/widgets/user-profile/subscription-plan/subscription-plan.component';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss']
})
export class AdminLayoutComponent implements OnInit {
  userData: any;
  sideBarOpen = true;
  isExpired = false;
  scrollStrategy: ScrollStrategy;

  isPWA = false;
  isRetailer = false;
  showInstallBox = false;
  isPartnerPortal = false;

  constructor(
    private _userInfoService: UserInfoService,
    private storageService: StorageService,
    public myapp: AppComponent,
    private dialog: MatDialog,
    private router: Router,
    private partnerPortalSidebarService: PartnerPortalSidebarService,
  ) {
    this.showInstallBox = this.myapp.showInstallPrompt;
  }

  ngOnInit(): void {
    this.userData = this._userInfoService.getUserInfo();
    if (this.userData?.planExpired && !isPartnerPortalUser(this.userData?.userType)) {
      this.sideBarOpen = false;
      this.isExpired = true;
      this.openPendingSubscriptionPlanModal();
    }

    if (this.userData?.userType) {
      this.isRetailer = this.userData.userType.includes(UserTypeEnum.RETAILER);
    }

    this.isPWA = window.matchMedia('(display-mode: standalone)').matches;

    this.storageService.pwaInstallSubject.subscribe(() => {
      this.isPWA = true;
      this.sideBarOpen = false;
    });

    if (this.isPWA) {
      this.sideBarOpen = false;
    }

    this.syncPartnerPortalRoute(this.router.url);
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(e => this.syncPartnerPortalRoute(e.urlAfterRedirects));
  }

  private syncPartnerPortalRoute(url: string): void {
    this.isPartnerPortal = url.includes('/admin/partner-portal');
  }

  sideBarToggler() {
    if (this.isPartnerPortal) {
      this.partnerPortalSidebarService.toggle();
      return;
    }
    this.sideBarOpen = !this.sideBarOpen;
  }

  openSubscriptionPlanExpired() {
    const dialogRef = this.dialog.open(DailogComponent, {
      disableClose: true,
      scrollStrategy: this.scrollStrategy,
      width: '100%',
      data: {
        title: 'Update Plans',
        component: SubscriptionPlanComponent
      }
    });
    dialogRef.afterClosed().subscribe(() => {});
  }

  private openPendingSubscriptionPlanModal() {
    setTimeout(() => this.openSubscriptionPlanExpired());
  }

  InstallPWA() {
    this.myapp.promptInstall();
  }
}
